import React, { useState } from "react";
import TextBox from "../../Common/TextBox";

type TextBoxVariant = "password" | "text" | "number";

const showPassIcon = (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.21736 1.38893C5.22182 1.3862 5.22627 1.38346 5.23073 1.38073L7.51199 3.662C7.50743 3.66462 7.50287 3.66725 7.49831 3.66989L8.99936 5.17093C9.00468 5.16905 9.01 5.16719 9.01533 5.16533L12.8347 8.98467C12.8328 8.99 12.8309 8.99532 12.8291 9.00064L14.3301 10.5017C14.3328 10.4971 14.3354 10.4926 14.338 10.488L16.8315 12.9815C16.8279 12.9851 16.8243 12.9887 16.8207 12.9922L17.5563 13.7279C17.9469 14.1184 17.9469 14.7516 17.5563 15.1421C17.1658 15.5327 16.5327 15.5327 16.1421 15.1421L15.2833 14.2833C13.7099 15.3787 11.9109 16 10 16C5.62584 16 1.83818 12.7443 0 8C0.838642 5.83549 2.08306 3.98083 3.60383 2.60383L2.70711 1.70711C2.31658 1.31658 2.31658 0.683417 2.70711 0.292893C3.09763 -0.097631 3.7308 -0.097631 4.12132 0.292893L5.21736 1.38893ZM5.99979 4.99979C5.37201 5.83549 5 6.8743 5 8C5 10.7614 7.23858 13 10 13C11.1257 13 12.1645 12.628 13.0002 12.0002L11.5619 10.5619C11.1069 10.8398 10.5722 11 10 11C8.34315 11 7 9.65685 7 8C7 7.42783 7.16018 6.89308 7.43813 6.43813L5.99979 4.99979Z"
      fill="#313131"
    />
    <path
      d="M15 8C15 8.10478 14.9968 8.20881 14.9904 8.312L18.1324 11.454C18.877 10.4317 19.5083 9.26913 20 8C18.1618 3.2557 14.3742 0 10 0C9.01601 0 8.06169 0.164755 7.15257 0.474149L9.688 3.00958C9.79119 3.00322 9.89522 3 10 3C12.7614 3 15 5.23858 15 8Z"
      fill="#313131"
    />
  </svg>
);

const hidePassIcon = (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 11C11.6569 11 13 9.65685 13 8C13 6.34315 11.6569 5 10 5C8.34315 5 7 6.34315 7 8C7 9.65685 8.34315 11 10 11Z"
      fill="#313131"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 8C1.83818 3.2557 5.62584 0 10 0C14.3742 0 18.1618 3.2557 20 8C18.1618 12.7443 14.3742 16 10 16C5.62584 16 1.83818 12.7443 0 8ZM15 8C15 10.7614 12.7614 13 10 13C7.23858 13 5 10.7614 5 8C5 5.23858 7.23858 3 10 3C12.7614 3 15 5.23858 15 8Z"
      fill="#313131"
    />
  </svg>
);

type Props = {
  label: string;
  value?: string;
  onChange?: (value: string) => void;
  name?: string;
  style?: React.CSSProperties;
  isInteger?: boolean;
  labelStyle?: React.CSSProperties;
  inputStyle?: React.CSSProperties;
  readOnly?: boolean;
  noBorder?: boolean;
  disabled?: boolean;
};

const ToolsContentTextBox = ({
  disabled = false,
  label,
  value = "",
  name = "",
  onChange = () => {},
  style,
  isInteger = false,
  labelStyle,
  inputStyle,
  readOnly = false,
  noBorder = false,
}: Props) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "left",
        marginBottom: 4.5,
        ...style,
      }}
    >
      <label
        style={{
          textAlign: "left",
          flex: 1,
          fontSize: 14,
          opacity: disabled ? 0.5 : 1,
          marginBottom: 6,
          ...labelStyle,
        }}
      >
        {label}
      </label>
      <div
        style={{
          // width: "100%",
          position: "relative",
          // justifyContent: "space-between",
          boxSizing: "border-box",
        }}
      >
        <TextBox
          disabled={disabled}
          name={name}
          onChange={(value) => onChange(value as string)}
          value={value}
          isInteger={isInteger}
          variant={showPassword ? "text" : "password"}
          readOnly={readOnly}
          style={{
            height: 33,
            background: "#FFFFFF",
            border: noBorder ? "0px" : "1px solid #414042",
            padding: "8px 10px",
            flex: 2,
            opacity: disabled ? 0.5 : 1,
            paddingRight: 33,
            fontSize: 14,
            width: "100%",
            ...inputStyle,
          }}
        />
        <button
          disabled={disabled}
          onClick={() => {
            setShowPassword(!showPassword);
          }}
          style={{
            border: "none",
            background: "none",
            position: "absolute",
            right: 0,
            width: 33,
            height: 33,
            cursor: disabled? "default" : "pointer",
            opacity: disabled? 0.35: 1,
          }}
        >
          {showPassword && showPassIcon}
          {!showPassword && hidePassIcon}
        </button>
      </div>
    </div>
  );
};

export default ToolsContentTextBox;
